<div class="heading">
    <p *ngIf="data?.isDelete">Delete Prompt</p>
    <p *ngIf="data?.isWithdraw">Withdraw Prompt</p>
</div>
<div class="instruction">
    <p class="mb-32" *ngIf="data?.isDelete" style="word-break: break-word;">Are you sure you want to permanently delete the “{{data?.prompt_name}}” prompt?</p>
    <p class="mb-32" *ngIf="data?.isDelete">This action cannot be undone.</p>
    <p *ngIf="data?.isWithdraw" style="word-break: break-word;">Are you sure you want to withdraw “{{data?.prompt_name}}”  prompt? It will be returned to the creator.</p>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12" (click)="cancelDeleteWithdraw()"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Withdraw'" class="w-50" (click)="withdrawPrompt()" *ngIf="data?.isWithdraw"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Delete'" class="w-50" (click)="deletePrompt()" *ngIf="data?.isDelete"></app-button>
</div>